import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";

function Login({ setIsAuth }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    const adminUsername = "sutsoadmin"; // Belirlediğiniz kullanıcı adı
    const adminPassword = "Sutso?2025."; // Belirlediğiniz şifre

    if (username === adminUsername && password === adminPassword) {
      setIsAuth(true); // Kullanıcıyı doğrula
      navigate("/admin-panel"); // Admin paneline yönlendir
    } else {
      setError("Hatalı kullanıcı adı veya şifre!"); // Hata mesajı
    }
  };

  return (
    <div className="login-container">
      <h1>Admin Giriş</h1>
      <form onSubmit={handleLogin}>
        <input
          type="text"
          placeholder="Kullanıcı Adı"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Şifre"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Giriş Yap</button>
      </form>
      {error && <p className="error">{error}</p>} {/* Hata mesajı */}
    </div>
  );
}

export default Login;
